const question8 = {
    'question': 'Ile trwa konsultacja psychologiczna?',
    'answer': 'Czas przeznaczony na jedno spotkanie z psychologiem to ok. 50 minut do godziny.'
}

export default question8;